import { Routes } from "@angular/router";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";

export const AppRoutes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full"
  },
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
      }
    ]
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule)
      }

    ]
  },
  {
    path: "**",
    redirectTo: "dashboard",
    pathMatch: "full"
  }
  //{
  //  path: "",
  //  redirectTo: "login",
  //  pathMatch: "full"
  //},
  //{
  //  path: "",
  //  component: AdminLayoutComponent,
  //  children: [
  //    {
  //      path: "",
  //      loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  //    }
  //  ]
  //},
  //{
  //  path: "",
  //  component: AuthLayoutComponent,
  //  children: [
  //    {
  //      path: "",
  //      loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule)
  //    }
  // 
  //  ]
  //},
  //{
  //  path: "**",
  //  redirectTo: "dashboard",
  //  pathMatch: "full"
  //},
];
